// import axios from "axios";
// import { useEffect, useState } from "react";
// import ApiUrl from "../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";
// import "../../assets/css/Loader.css";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import * as XLSX from "xlsx";

// function Supplier() {
//   // Modal state
//   const toast = useToast(); // Use the toast hook
//   const [loading, setLoading] = useState(false); // Initialize as true to show spinner on first load
//   const [showModal, setShowModal] = useState(false);
//   const [updateModal, setUpdateModal] = useState(false);
//   const [generate , setgenerate] = useState([]);

//   // Open and close modal functions
//   const openModal = () => setShowModal(true);
//   const closeModal = () => setShowModal(false);

//   const [formErrors, setFormErrors] = useState({});
//   // get method
//   const [responseData, setResponseData] = useState([]);

//   useEffect(() => {
//     fetchData();
//     fetchgenerate()
//   }, []);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${ApiUrl}/Api/supplier.php`);
//       console.log("Response from server:", response.data);
//       setResponseData(response.data?.data || []);
//       setTimeout(() => {
//         setLoading(false);
//       }, 1000);
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       toast.error("Failed to fetch data", 3000, "topRight");
//     }
//   };

//     const fetchgenerate = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${ApiUrl}/Api/supplier.php/generate-supplier-code`);
//       console.log("Response from server:", response.data);
//       setgenerate (response.data.supplier_id || []);

//   setAddData((prev) => ({
//         ...prev,
//         supplier_id: response.data?.supplier_id || "",
//       }));

//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       toast.error("Failed to fetch data", 3000, "topRight");
//     }
//   };
//   // add method
//   const [addData, setAddData] = useState({
//     supplier_id: "",
//     name: "",
//     mobile: "",
//     address: "",
//     status: "",
//     created_by: "",
//     created_date: "",
//     updated_by: "",
//     updated_date: "",
//   });

//   // Add user
//   const handlesubmit = async (e) => {
//     e.preventDefault();

//  // Validate required fields before proceeding
//   const errors = {};
//   if (!addData.supplier_id) errors.supplier_id = "Supplier Id is required";
//   if (!addData.name) errors.name = "Name is required";
//   if (!addData.mobile) errors.mobile = "Mobile Number is required";
//   if (!addData.address) errors.address = "Address is required";
//   if (!addData.status) errors.status = "Status is required";

//   if (Object.keys(errors).length > 0) {
//     setFormErrors(errors);
//     return; // stop submission if errors exist
//   } else {
//     setFormErrors({}); // clear errors
//   }

//     try {
//       setLoading(true);
//       const formData = {
//         supplier_id: addData.supplier_id,
//         name: addData.name,
//         mobile: addData.mobile,
//         address: addData.address,
//         status: addData.status,
//         created_by: "",
//         created_date: "",
//         updated_by: "",
//         updated_date: "",
//       };
//       const response = await axios.post(`${ApiUrl}/Api/supplier.php`, formData);
//       console.log("Submit data:", response);
//       setShowModal(false);
//       setTimeout(() => {
//         setLoading(false);
//       }, 1000);
//       toast.success("Added successfully!", 3000, "topRight");
//       // toast.success("Added successfully!");
//       setAddData({
//         supplier_id: "",
//         name: "",
//         mobile: "",
//         address: "",
//         status: "",
//         created_by: "",
//         created_date: "",
//         updated_by: "",
//         updated_date: "",
//       });
//       fetchData();
//     } catch (error) {
//       console.error("Error updating data:", error.message);
//       toast.error("Failed to Added data", 3000, "topRight");
//     }
//   };

//   // update method
//   const closeUpdateModal = () => setUpdateModal(false);

//   const [updateData, setUpdateData] = useState({
//     supplier_id: "",
//     name: "",
//     mobile: "",
//     address: "",
//     status: "",
//     created_by: "",
//     created_date: "",
//     updated_by: "",
//     updated_date: "",
//   });

//   const [updateid, setUpdateId] = useState("");

//   const handleUpdate = (id, data) => {
//     setUpdateId(id);
//     console.log("The data to update", data);
//     setUpdateModal(true);
//     setUpdateData({
//       supplier_id: data.supplier_id,
//       name: data.name,
//       mobile: data.mobile,
//       address: data.address,
//       status: data.status,
//       created_by: "",
//       created_date: "",
//       updated_by: "",
//       updated_date: "",
//     });
//   };

//   // Update user
//   const handleupdatesubmit = async (e) => {
//     e.preventDefault();
//     try {
//       setLoading(true);
//       const formData = {
//         supplier_id: updateData.supplier_id,
//         name: updateData.name,
//         mobile: updateData.mobile,
//         address: updateData.address,
//         status: updateData.status,
//         created_by: "",
//         created_date: "",
//         updated_by: "",
//         updated_date: "",
//       };

//       console.log("The update submit data", formData);
//       const response = await axios.put(
//         ApiUrl + `/Api/supplier.php/${updateid}`,
//         formData
//       );
//       console.log("Response for update", response);
//       setUpdateModal(false);

//       toast.success("Updated successfully!", 3000, "topRight");
//       // toast.success("Update successfully!");
//       setTimeout(() => {
//         setLoading(false);
//       }, 1000);
//       fetchData();
//     } catch (error) {
//       console.error("Error updating data:", error.message);
//       toast.error("Failed to fetch data", 3000, "topRight");
//     } finally {
//       setTimeout(() => {
//         setLoading(false);
//       }, 1000);
//     }
//   };

//   // delete method
//   const [deleteShowModals, setDeleteShowModals] = useState(false); // Delete modal
//   const [getdeleteid, setdeleteid] = useState("");
//   const [getdeletename, setdeletename] = useState("");

//   // Delete confirmation modal
//   const handleOpenModal = (id, supplier_id) => {
//     setdeleteid(id);
//     setdeletename(supplier_id);
//     setDeleteShowModals(true);
//   };

//   const handleCloseModal = () => {
//     setDeleteShowModals(false);
//   };

//   const handleDelete = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.delete(
//         `${ApiUrl}/Api/supplier.php/${getdeleteid}`
//       );
//       console.log("Delete data ", response);
//       // toast.error("Delete successfully!");
//       setDeleteShowModals(false);
//       toast.success("Deleted successfully!", 3000, "topRight");

//       setTimeout(() => {
//         setLoading(false);
//       }, 1000);
//       fetchData();
//     } catch (error) {
//       console.error("Error deleting data:", error.message);

//       toast.error("Failed to delete data", 3000, "topRight");
//     } finally {
//       setTimeout(() => {
//         setLoading(false);
//       }, 1000);
//     }
//   };

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [showAllItems, setShowAllItems] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   // Filter data based on search term
//   const filteredData = responseData.filter((item) => {
//     const searchLower = searchTerm.toLowerCase();
//     return (
//       (item.supplier_id &&
//         item.supplier_id.toLowerCase().includes(searchLower)) ||
//       (item.name && item.name.toLowerCase().includes(searchLower)) ||
//       (item.mobile && item.mobile.toLowerCase().includes(searchLower)) ||
//       (item.address && item.address.toLowerCase().includes(searchLower)) ||
//       (item.status && item.status.toLowerCase().includes(searchLower))
//     );
//   });

//   // Calculate pagination values
//   const totalItems = filteredData.length;
//   const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);

//   // Get current items for pagination
//   const currentItems = showAllItems
//     ? filteredData
//     : filteredData.slice(
//         (currentPage - 1) * itemsPerPage,
//         currentPage * itemsPerPage
//       );

//   const handlePageChange = (page) => {
//     if (page < 1 || page > totalPages) return;
//     setCurrentPage(page);
//   };

//   const handleItemsPerPageChange = (e) => {
//     const value = e.target.value;
//     if (value === "All") {
//       setShowAllItems(true);
//       setCurrentPage(1);
//     } else {
//       setShowAllItems(false);
//       setItemsPerPage(Number(value));
//       setCurrentPage(1); // Reset to first page when changing items per page
//     }
//   };

//   const renderPageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 2; // Number of page buttons to show

//     // Calculate range of pages to display
//     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
//     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

//     // Adjust if we're at the beginning or end
//     if (endPage - startPage + 1 < maxVisiblePages) {
//       startPage = Math.max(1, endPage - maxVisiblePages + 1);
//     }

//     // First page and ellipsis
//     if (startPage > 1) {
//       pages.push(
//         <li
//           key={1}
//           className={`page-item ${currentPage === 1 ? "active" : ""}`}
//         >
//           <button className="page-link" onClick={() => handlePageChange(1)}>
//             1
//           </button>
//         </li>
//       );
//       if (startPage > 2) {
//         pages.push(
//           <li key="start-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//     }

//     // Visible page numbers
//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(
//         <li
//           key={i}
//           className={`page-item ${currentPage === i ? "active" : ""}`}
//         >
//           <button className="page-link" onClick={() => handlePageChange(i)}>
//             {i}
//           </button>
//         </li>
//       );
//     }

//     // Last page and ellipsis
//     if (endPage < totalPages) {
//       if (endPage < totalPages - 1) {
//         pages.push(
//           <li key="end-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//       pages.push(
//         <li
//           key={totalPages}
//           className={`page-item ${currentPage === totalPages ? "active" : ""}`}
//         >
//           <button
//             className="page-link"
//             onClick={() => handlePageChange(totalPages)}
//           >
//             {totalPages}
//           </button>
//         </li>
//       );
//     }

//     return pages;
//   };

//   // Export Functions
//   const handlePrint = () => {
//     const printWindow = window.open("", "_blank");
//     const printContent = `
//       <html>
//         <head>
//           <title>Suppliers List</title>
//           <style>
//             body { font-family: Arial, sans-serif; margin: 20px; }
//             h1 { color: #333; text-align: center; margin-bottom: 30px; }
//             table { border-collapse: collapse; width: 100%; margin-top: 20px; }
//             th, td { border: 1px solid #ddd; padding: 12px; text-align: left; }
//             th { background-color: #f2f2f2; font-weight: bold; }
//             tr:nth-child(even) { background-color: #f9f9f9; }
//             .status-active { background-color: #d4edda; color: #155724; padding: 4px 8px; border-radius: 4px; }
//             .status-inactive { background-color: #f8d7da; color: #721c24; padding: 4px 8px; border-radius: 4px; }
//             @media print { body { margin: 0; } }
//           </style>
//         </head>
//         <body>
//           <h1>Suppliers List</h1>
//           <table>
//             <thead>
//               <tr>
//                 <th>S.No</th>
//                 <th>Supplier ID</th>
//                 <th>Name</th>
//                 <th>Address</th>
//                 <th>Mobile Number</th>
//                 <th>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               ${filteredData
//                 .map(
//                   (item, index) => `
//                 <tr>
//                   <td>${index + 1}</td>
//                   <td>${item.supplier_id || ""}</td>
//                   <td>${item.name || ""}</td>
//                   <td>${item.address || ""}</td>
//                   <td>${item.mobile || ""}</td>
//                   <td>
//                     <span class="status-${
//                       item.status === "Active" ? "active" : "inactive"
//                     }">
//                       ${item.status || ""}
//                     </span>
//                   </td>
//                 </tr>
//               `
//                 )
//                 .join("")}
//             </tbody>
//           </table>
//           <p style="margin-top: 20px; text-align: center; color: #666;">
//             Total Records: ${
//               filteredData.length
//             } | Generated on: ${new Date().toLocaleString()}
//           </p>
//         </body>
//       </html>
//     `;

//     printWindow.document.write(printContent);
//     printWindow.document.close();
//     printWindow.focus();
//     setTimeout(() => {
//       printWindow.print();
//       printWindow.close();
//     }, 250);
//           toast.success("Print dialog opened!", 2000, "topRight");
//   };

//   const exportPDF = () => {
//     try{
//     const doc = new jsPDF();

//     // Add title
//     doc.setFontSize(18);
//     doc.setTextColor(40, 40, 40);
//     doc.text("Suppliers List", 14, 22);

//     // Add generation date
//     doc.setFontSize(10);
//     doc.setTextColor(100, 100, 100);
//     doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 30);

//     // Prepare table data
//     const tableColumns = [
//       "S.No",
//       "Supplier ID",
//       "Name",
//       "Address",
//       "Mobile Number",
//       "Status",
//     ];
//     const tableRows = filteredData.map((item, index) => [
//       index + 1,
//       item.supplier_id || "",
//       item.name || "",
//       item.address || "",
//       item.mobile || "",
//       item.status || "",
//     ]);

//     // Add table
//     autoTable(doc, {
//       head: [tableColumns],
//       body: tableRows,
//       startY: 35,
//       theme: "striped",
//       headStyles: {
//         fillColor: [71, 71, 71],
//         textColor: [255, 255, 255],
//         fontSize: 10,
//         fontStyle: "bold",
//       },
//       bodyStyles: {
//         fontSize: 9,
//         cellPadding: 3,
//       },
//       alternateRowStyles: {
//         fillColor: [245, 245, 245],
//       },
//       margin: { top: 35, right: 14, bottom: 20, left: 14 },
//       didDrawCell: (data) => {
//         // Color code status cells
//         if (data.column.index === 5 && data.cell.section === "body") {
//           const status = data.cell.text[0];
//           if (status === "Active") {
//             doc.setFillColor(212, 237, 218);
//             doc.rect(
//               data.cell.x,
//               data.cell.y,
//               data.cell.width,
//               data.cell.height,
//               "F"
//             );
//             doc.setTextColor(21, 87, 36);
//             doc.text(
//               status,
//               data.cell.x + 2,
//               data.cell.y + data.cell.height / 2 + 1
//             );
//           } else if (status === "Inactive") {
//             doc.setFillColor(248, 215, 218);
//             doc.rect(
//               data.cell.x,
//               data.cell.y,
//               data.cell.width,
//               data.cell.height,
//               "F"
//             );
//             doc.setTextColor(114, 28, 36);
//             doc.text(
//               status,
//               data.cell.x + 2,
//               data.cell.y + data.cell.height / 2 + 1
//             );
//           }
//         }
//       },
//     });

//     // Add footer
//     const pageCount = doc.internal.getNumberOfPages();
//     for (let i = 1; i <= pageCount; i++) {
//       doc.setPage(i);
//       doc.setFontSize(8);
//       doc.setTextColor(150, 150, 150);
//       doc.text(
//         `Page ${i} of ${pageCount}`,
//         doc.internal.pageSize.width - 30,
//         doc.internal.pageSize.height - 10
//       );
//       doc.text(
//         `Total Records: ${filteredData.length}`,
//         14,
//         doc.internal.pageSize.height - 10
//       );
//     }

//     // Save the PDF
//     doc.save(`Suppliers_List_${new Date().toISOString().split("T")[0]}.pdf`);

// toast.success("PDF exported successfully!", 3000, "topRight");
//     } catch (error) {
//       toast.error("Failed to export PDF", 3000, "topRight");
//     }
//   };

//  const copyToClipboard = () => {
//   try {
//     const headers = [
//       "S.No",
//       "Supplier ID",
//       "Name",
//       "Address",
//       "Mobile Number",
//       "Status",
//     ];

//     const rows = (filteredData || []).map((item, index) => [
//       index + 1,
//       item.supplier_id || "",
//       item.name || "",
//       item.address || "",
//       item.mobile || "",
//       item.status || "",
//     ]);

//     // Quote every field to handle tabs/newlines safely, then tab-delimit, then newline delimit
//     const csvData = [headers, ...rows]
//       .map(row => row.map(field => `"${field}"`).join('\t'))
//       .join('\n');

//     if (navigator.clipboard && navigator.clipboard.writeText) {
//       navigator.clipboard.writeText(csvData)
//         .then(() => {
//           toast.success("Data copied to clipboard!", 3000, "topRight");
//         })
//         .catch(err => {
//           console.error('Clipboard API failed:', err);
//           fallbackCopy(csvData);
//         });
//     } else {
//       fallbackCopy(csvData);
//     }
//   } catch (error) {
//     console.error('Unexpected error copying to clipboard:', error);
//     toast.error("Failed to copy data", 3000, "topRight");
//   }
// };

// const fallbackCopy = (text) => {
//   try {
//     const textArea = document.createElement("textarea");
//     textArea.value = text;

//     // Style the textarea to be invisible
//     textArea.style.position = "fixed";
//     textArea.style.top = 0;
//     textArea.style.left = 0;
//     textArea.style.width = '2em';
//     textArea.style.height = '2em';
//     textArea.style.padding = 0;
//     textArea.style.border = 'none';
//     textArea.style.outline = 'none';
//     textArea.style.boxShadow = 'none';
//     textArea.style.background = 'transparent';

//     document.body.appendChild(textArea);
//     textArea.focus();
//     textArea.select();

//     const successful = document.execCommand('copy');
//     document.body.removeChild(textArea);

//     if (successful) {
//       toast.success("Data copied to clipboard!", 3000, "topRight");
//     } else {
//       toast.error("Failed to copy data", 3000, "topRight");
//     }
//   } catch (err) {
//     console.error('Fallback copy failed:', err);
//     toast.error("Failed to copy data", 3000, "topRight");
//   }
// };

//   const exportCSV = () => {
//     const headers = [
//       "S.No",
//       "Supplier ID",
//       "Name",
//       "Address",
//       "Mobile Number",
//       "Status",
//     ];
//     const rows = filteredData.map((item, index) => [
//       index + 1,
//       item.supplier_id || "",
//       item.name || "",
//       item.address || "",
//       item.mobile || "",
//       item.status || "",
//     ]);

//     const csvContent = [headers, ...rows]
//       .map((row) => row.map((field) => `"${field}"`).join(","))
//       .join("\n");

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const link = document.createElement("a");
//     const url = URL.createObjectURL(blob);
//     link.setAttribute("href", url);
//     link.setAttribute(
//       "download",
//       `Suppliers_List_${new Date().toISOString().split("T")[0]}.csv`
//     );
//     link.style.visibility = "hidden";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//      toast.success("CSV exported successfully!", 3000, "topRight");
//   };

//   const exportExcel = () => {
//     try{
//     const headers = [
//       "S.No",
//       "Supplier ID",
//       "Name",
//       "Address",
//       "Mobile Number",
//       "Status",
//     ];
//     const rows = filteredData.map((item, index) => [
//       index + 1,
//       item.supplier_id || "",
//       item.name || "",
//       item.address || "",
//       item.mobile || "",
//       item.status || "",
//     ]);

//     const wsData = [headers, ...rows];
//     const ws = XLSX.utils.aoa_to_sheet(wsData);

//     // Set column widths
//     const wscols = [
//       { wch: 8 }, // S.No
//       { wch: 15 }, // Supplier ID
//       { wch: 20 }, // Name
//       { wch: 30 }, // Address
//       { wch: 15 }, // Mobile Number
//       { wch: 12 }, // Status
//     ];
//     ws["!cols"] = wscols;

//     // Style the header row
//     const headerStyle = {
//       font: { bold: true, color: { rgb: "FFFFFF" } },
//       fill: { fgColor: { rgb: "4472C4" } },
//       alignment: { horizontal: "center", vertical: "center" },
//     };

//     // Apply header styling
//     for (let i = 0; i < headers.length; i++) {
//       const cellRef = XLSX.utils.encode_cell({ r: 0, c: i });
//       if (ws[cellRef]) {
//         ws[cellRef].s = headerStyle;
//       }
//     }

//     // Create workbook and add worksheet
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Suppliers");

//     // Add metadata
//     wb.Props = {
//       Title: "Suppliers List",
//       Subject: "Suppliers Data Export",
//       Author: "Supplier Management System",
//       CreatedDate: new Date(),
//     };

//     // Save the file
//     XLSX.writeFile(
//       wb,
//       `Suppliers_List_${new Date().toISOString().split("T")[0]}.xlsx`
//     );
//       toast.success("Excel exported successfully!", 3000, "topRight");
//     } catch (error) {
//       toast.error("Failed to export Excel", 3000, "topRight");
//     }
//   };

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}

//       <div className="container-fluid py-3">
//         {/* Add Customer Button */}
//         <div className="d-flex mb-4">
//           <h6 className="card-title m-2">Suppliers</h6>
//           <button
//             className="btn btn-primary btn-sm rounded-3"
//             onClick={openModal}
//           >
//             Add <span className="ms-2">+</span>
//           </button>
//         </div>

//         {/* Customer List Card */}
//         <div className="card shadow-sm">
//           <div className="card-body">
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               {/* Left side - Show per page */}
//               <div className="d-flex">
//                 <label className="form-label text-dark mt-2">Show : </label>
//                 <div>
//                   <select
//                     className="form-control mx-2"
//                     onChange={handleItemsPerPageChange}
//                     value={showAllItems ? "All" : itemsPerPage}
//                   >
//                     <option value="All">All</option>
//                     {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
//                       <option key={pageSize} value={pageSize}>
//                         {pageSize}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               {/* Center - Export/Action buttons */}
//               <div className="d-flex justify-content-center">
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={handlePrint}
//                 >
//                   Print
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportPDF}
//                 >
//                   PDF
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={copyToClipboard}
//                 >
//                   Copy
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportCSV}
//                 >
//                   CSV
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportExcel}
//                 >
//                   Excel
//                 </button>
//               </div>
//               {/* Right side - Search */}
//               <div className="search-container">
//                 <div className="input-group">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search"
//                     aria-label="Search"
//                     value={searchTerm}
//                     onChange={(e) => {
//                       setSearchTerm(e.target.value);
//                       setCurrentPage(1); // Reset to first page when searching
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Table */}
//             <div className="card tableCard p-2">
//               <div className="table-container">
//                 <table className="table table-layout-fixed w-100">
//                   <thead className="bg-light">
//                     <tr>
//                       <th>S.No</th>
//                       <th>Suppliers_Id</th>
//                       <th>Name</th>
//                       <th>Address</th>
//                       <th>Mobile Number</th>
//                       <th>Status</th>
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentItems.map((item, index) => (
//                       <tr key={index}>
//                         <td>{index + 1}</td>
//                         <td>{item.supplier_id}</td>
//                         <td>{item.name}</td>
//                         <td>{item.address}</td>
//                         <td>{item.mobile}</td>
//                         <td>
//                           {item.status === "Active" ? (
//                             <span className="badge bg-success text-white">
//                               Active
//                             </span>
//                           ) : item.status === "Inactive" ? (
//                             <span className="badge bg-danger text-white">
//                               Inactive
//                             </span>
//                           ) : (
//                             <span className="badge bg-secondary text-white">
//                               {item.status}
//                             </span>
//                           )}
//                         </td>
//                         <td>
//                           <button
//                             className="btn btn-light btn-sm mx-1"
//                             onClick={() => handleUpdate(item.id, item)}
//                           >
//                             <i class="fa-solid fa-pen-to-square text-primary fs-6"></i>
//                             {/* <i className="bi bi-pencil text-primary fs-6"></i> */}
//                           </button>

//                           <button
//                             className="btn btn-light btn-sm"
//                             onClick={() =>
//                               handleOpenModal(item.id, item.supplier_id)
//                             }
//                           >
//                             {/* <i className="bi bi-trash text-danger fs-6"></i> */}
//                             <i class="fa-solid fa-trash text-danger fs-6"></i>
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               <div className="row">
//                 <div className="col-lg-6">
//                   <p className="text-muted">
//                     Showing{" "}
//                     {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
//                     {showAllItems
//                       ? totalItems
//                       : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
//                     of {totalItems} entries
//                   </p>
//                 </div>
//                 <div className="col-lg-6">
//                   <nav aria-label="Page navigation">
//                     <ul className="pagination justify-content-end">
//                       <li
//                         className={`page-item ${
//                           currentPage === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(1)}
//                           aria-label="First"
//                         >
//                           <span aria-hidden="true">&laquo;&laquo;</span>
//                         </button>
//                       </li>
//                       <li
//                         className={`page-item ${
//                           currentPage === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage - 1)}
//                           aria-label="Previous"
//                         >
//                           <span aria-hidden="true">&laquo;</span>
//                         </button>
//                       </li>

//                       {renderPageNumbers()}

//                       <li
//                         className={`page-item ${
//                           currentPage === totalPages || totalPages === 0
//                             ? "disabled"
//                             : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage + 1)}
//                           aria-label="Next"
//                         >
//                           <span aria-hidden="true">&raquo;</span>
//                         </button>
//                       </li>
//                       <li
//                         className={`page-item ${
//                           currentPage === totalPages || totalPages === 0
//                             ? "disabled"
//                             : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(totalPages)}
//                           aria-label="Last"
//                         >
//                           <span aria-hidden="true">&raquo;&raquo;</span>
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Customer Add Modal */}
//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{ display: showModal ? "block" : "none" }}
//         tabIndex="-1"
//         aria-labelledby="addCustomerModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6
//                 className="modal-title text-primary"
//                 id="addCustomerModalLabel"
//               >
//                 Add Supplier
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={closeModal}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <form>
//                 <div className="row">
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="UserId" className="form-label">
//                         Suppliers_ID
//                       </label>
//                       <input
//                         type="text"
//                         className={`form-control ${formErrors.supplier_id ? "is-invalid" : ""}`}

//                         id="supplier_id"
//                         placeholder="Enter Suppliers_ID"
//                         value={generate}
//                         onChange={(e) =>
//                           setAddData({
//                             ...addData,
//                             supplier_id: e.target.value,
//                           })
//                         }
//                         disabled
//                       />
//                        {formErrors.supplier_id && <div className="invalid-feedback">{formErrors.supplier_id}</div>}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="Name" className="form-label">
//                         Name
//                       </label>
//                       <input
//                         type="text"
//                      className={`form-control ${formErrors.name ? "is-invalid" : ""}`}
//                         id="name"
//                         placeholder="Enter Name"
//                         value={addData.name}
//                         onChange={(e) =>
//                           setAddData({
//                             ...addData,
//                             name: e.target.value,
//                           })
//                         }
//                       />
//                        {formErrors.name && <div className="invalid-feedback">{formErrors.name}</div>}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="mb-3">
//                   <label htmlFor="Mobile" className="form-label">
//                     Mobile Number
//                   </label>
//                   <input
//                     type="tel"
//                     className={`form-control ${formErrors.mobile ? "is-invalid" : ""}`}
//                     id="mobile"
//                     placeholder="Enter Mobile Number"
//                     value={addData.mobile}
//                     onChange={(e) =>
//                       setAddData({
//                         ...addData,
//                         mobile: e.target.value,
//                       })
//                     }
//                   />
//                     {formErrors.mobile && <div className="invalid-feedback">{formErrors.mobile}</div>}
//                 </div>

//                 <div className="mb-3">
//                   <label htmlFor="Address" className="form-label">
//                     Address
//                   </label>
//                   <input
//                     type="tel"
//                   className={`form-control ${formErrors.address ? "is-invalid" : ""}`}
//                     id="address"
//                     placeholder="Enter Address"
//                     value={addData.address}
//                     onChange={(e) =>
//                       setAddData({
//                         ...addData,
//                         address: e.target.value,
//                       })
//                     }
//                   />
//                     {formErrors.address && <div className="invalid-feedback">{formErrors.address}</div>}
//                 </div>

//                 <div className="mb-3">
//                   <label htmlFor="customerStatus" className="form-label">
//                     Status
//                   </label>
//                   <select
//                       className={`form-select ${formErrors.status ? "is-invalid" : ""}`}
//                     id="status"
//                     value={addData.status}
//                     onChange={(e) =>
//                       setAddData({ ...addData, status: e.target.value })
//                     }
//                   >
//                     <option value="">Select Status</option>
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                     {formErrors.status && <div className="invalid-feedback">{formErrors.status}</div>}
//                 </div>

//                 <div className="text-center mt-4">
//                   <button
//                     type="submit"
//                     className="btn btn-primary btn-sm px-4"
//                     onClick={handlesubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Customer Update Modal */}
//       <div
//         className={`modal fade ${updateModal ? "show" : ""}`}
//         style={{ display: updateModal ? "block" : "none" }}
//         tabIndex="-1"
//         aria-labelledby="updateCustomerModalLabel"
//         aria-hidden={!updateModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6
//                 className="modal-title text-primary"
//                 id="updateCustomerModalLabel"
//               >
//                 Update Supplier
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={closeUpdateModal}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <form>
//                 <div className="row">
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="UserId" className="form-label">
//                         Suppliers_ID
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="supplier_id"
//                         placeholder="Enter Supplier_ID"
//                         value={updateData.supplier_id}
//                         onChange={(e) =>
//                           setUpdateData({
//                             ...updateData,
//                             supplier_id: e.target.value,
//                           })
//                         }
//                         disabled
//                       />
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="Name" className="form-label">
//                         Name
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="name"
//                         placeholder="Enter Name"
//                         value={updateData.name}
//                         onChange={(e) =>
//                           setUpdateData({
//                             ...updateData,
//                             name: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="mb-3">
//                   <label htmlFor="Mobile" className="form-label">
//                     Mobile Number
//                   </label>
//                   <input
//                     type="tel"
//                     className="form-control"
//                     id="mobile"
//                     placeholder="Enter Mobile"
//                     value={updateData.mobile}
//                     onChange={(e) =>
//                       setUpdateData({
//                         ...updateData,
//                         mobile: e.target.value,
//                       })
//                     }
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <label htmlFor="Address" className="form-label">
//                     Address
//                   </label>
//                   <input
//                     type="tel"
//                     className="form-control"
//                     id="address"
//                     placeholder="Enter Address"
//                     value={updateData.address}
//                     onChange={(e) =>
//                       setUpdateData({
//                         ...updateData,
//                         address: e.target.value,
//                       })
//                     }
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <label htmlFor="customerStatus" className="form-label">
//                     Status
//                   </label>
//                   <select
//                     className="form-select"
//                     id="status"
//                     value={updateData.status}
//                     onChange={(e) =>
//                       setUpdateData({ ...updateData, status: e.target.value })
//                     }
//                   >
//                     <option value="" disabled>
//                       Select Status
//                     </option>
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                 </div>

//                 <div className="text-center mt-4">
//                   <button
//                     type="submit"
//                     className="btn btn-primary btn-sm px-4"
//                     onClick={handleupdatesubmit}
//                   >
//                     Update
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Delete Confirmation Modal */}
//       <div
//         className={`modal fade ${deleteShowModals ? "show" : ""}`}
//         style={{
//           display: deleteShowModals ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//         aria-labelledby="deleteConfirmModalLabel"
//         aria-modal="true"
//       >
//         <div className="modal-dialog modal-dialog-centered modal-confirm">
//           <div className="modal-content">
//             <div className="modal-body text-center">
//               <div className="d-flex justify-content-center mb-3">
//                 <div
//                   className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
//                   style={{
//                     width: "80px",
//                     height: "80px",
//                     margin: "0 auto",
//                   }}
//                 >
//                   <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
//                 </div>
//               </div>

//               <h4 className="modal-title mb-3 text-center">Are you sure?</h4>
//               <h6 className="mb-4 text-center">
//                 Do you really want to delete this
//                 <span className="text-primary">({getdeletename}</span>
//                 )?
//               </h6>

//               <div className="d-flex btn-group">
//                 <button
//                   type="button"
//                   className="btn btn-secondary btn-sm flex-grow-1"
//                   onClick={handleCloseModal}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-danger btn-sm flex-grow-1 mx-2"
//                   onClick={handleDelete}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Modal backdrop */}
//       {(showModal || updateModal || deleteShowModals) && (
//         <div className="modal-backdrop fade show"></div>
//       )}
//     </>
//   );
// }

// export default Supplier;

import axios from "axios";
import { useEffect, useState } from "react";
import ApiUrl from "../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";
import "../../assets/css/Loader.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

function Supplier() {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [actionType, setActionType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(2); // Default notification count set to 2
  const [selectedSupplierId, setSelectedSupplierId] = useState(null);
  const [responseData, setResponseData] = useState([]);
  const [generateNumber, setGenerateNumber] = useState("");
  const [updateId, setUpdateId] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [deleteName, setDeleteName] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [addData, setAddData] = useState({
    supplier_id: "",
    name: "",
    mobile: "",
    address: "",
    status: "",
    created_by: "",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });
  const [updateData, setUpdateData] = useState({
    id: "",
    supplier_id: "",
    name: "",
    mobile: "",
    address: "",
    status: "",
    created_by: "",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const openModal = () => {
    setShowModal(true);
    fetchGenerate();
  };

  const closeModal = () => {
    setShowModal(false);
    setAddData({
      supplier_id: "",
      name: "",
      mobile: "",
      address: "",
      status: "",
      created_by: "",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
    setGenerateNumber("");
    setFormErrors({});
    setActionType("");
  };

  const closeUpdateModal = () => {
    setUpdateModal(false);
    setUpdateData({
      id: "",
      supplier_id: "",
      name: "",
      mobile: "",
      address: "",
      status: "",
      created_by: "",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
    setGenerateNumber("");
    setFormErrors({});
  };

  const openNotificationModal = (id, action) => {
    setSelectedSupplierId(id);
    setActionType(action);
    setShowModal(true);
  };

  const closeNotificationModal = () => {
    setShowModal(false);
    setSelectedSupplierId(null);
    setActionType("");
    setIsSubmitting(false);
  };

  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/notification.php`);
      const notificationData = response.data?.data || [];
      setNotifications(notificationData);
      // Set notification count: default to 2 if no notifications, else use the length of notifications
      setNotificationCount(
        notificationData.length > 0 ? notificationData.length : 2
      );
    } catch (error) {
      console.error("Error fetching notifications:", error.message);
      toast.error("Failed to fetch notifications", 3000, "topRight");
    }
  };

  const checkNotificationStatus = (supplierId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === supplierId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "accepted" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  const hasPendingNotification = (supplierId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === supplierId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "requested" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  const handleNotificationSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isSubmitting) return;
    setIsSubmitting(true);

    if (hasPendingNotification(selectedSupplierId, actionType)) {
      toast.warning(
        "A pending request for this action already exists!",
        3000,
        "topRight"
      );
      closeNotificationModal();
      return;
    }

    try {
      const userId = localStorage.getItem("username");
      const currentTime = new Date()
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");

      const formData = {
        table_name: "supplier",
        table_id: selectedSupplierId,
        employe_id: userId || "",
        status: "requested",
        button_value: actionType,
        time: currentTime,
        viewed: "false",
        created_date: currentTime,
        updated_by: userId || "",
        updated_date: currentTime,
      };

      await axios.post(`${ApiUrl}/Api/notification.php`, formData, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success(
        `${actionType} request sent successfully!`,
        3000,
        "topRight"
      );
      closeNotificationModal();
      fetchNotifications();
    } catch (error) {
      console.error("Error submitting notification:", error.message);
      toast.error(
        "Error submitting notification. Please try again.",
        3000,
        "topRight"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const fetchData = async () => {
    try {
      const localRole = localStorage.getItem("role");
      const localUsername = localStorage.getItem("username");
      const response = await axios.get(
        localRole === "Employee"
          ? `${ApiUrl}/Api/supplier.php?employee_id=${localUsername}`
          : `${ApiUrl}/Api/supplier.php`
      );
      console.log("Response from server:", response.data);
      const reversedData = (response.data?.data || []).slice().reverse();
      setResponseData(reversedData);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      toast.error("Failed to fetch data", 3000, "topRight");
    }
  };

  const fetchGenerate = async () => {
    try {
      const response = await axios.get(
        `${ApiUrl}/Api/supplier.php/generate-supplier-code`
      );
      const data = response.data?.supplier_id || "";
      setGenerateNumber(data);
      setAddData((prev) => ({
        ...prev,
        supplier_id: data,
      }));
    } catch (error) {
      console.error("Error fetching generated ID:", error.message);
      toast.error("Failed to fetch generated ID", 3000, "topRight");
    }
  };

  const validateForm = (data) => {
    const errors = {};
    if (!data.supplier_id) errors.supplier_id = "Supplier ID is required";
    if (!data.name) errors.name = "Name is required";
    if (!data.mobile) {
      errors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(data.mobile)) {
      errors.mobile = "Mobile number must be 10 digits";
    }
    if (!data.address) errors.address = "Address is required";
    if (!data.status || data.status === "Select Status") {
      errors.status = "Status is required";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (!validateForm(addData)) return;

    try {
      setLoading(true);
      const formData = {
        ...addData,
        created_date: new Date().toISOString().slice(0, 19).replace("T", " "),
        updated_date: new Date().toISOString().slice(0, 19).replace("T", " "),
      };
      await axios.post(`${ApiUrl}/Api/supplier.php`, formData);
      toast.success("Added successfully!", 3000, "topRight");
      closeModal();
      fetchData();
      // Increment notification count when a supplier is added
      setNotificationCount((prev) => prev + 1);
      // Optionally, add a new notification to the notifications array
      const userId = localStorage.getItem("username");
      const currentTime = new Date()
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");
      const newNotification = {
        table_name: "supplier",
        table_id: formData.supplier_id,
        employe_id: userId || "",
        status: "added",
        button_value: "Add",
        time: currentTime,
        viewed: "false",
        created_date: currentTime,
        updated_by: userId || "",
        updated_date: currentTime,
      };
      setNotifications((prev) => [...prev, newNotification]);
    } catch (error) {
      console.error("Error adding data:", error.message);
      toast.error("Failed to add data", 3000, "topRight");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleUpdate = (id, data) => {
    const userRole = localStorage.getItem("role");

    if (userRole === "Employee") {
      if (checkNotificationStatus(id, "Edit")) {
        setUpdateId(id);
        setUpdateData({
          id,
          supplier_id: data.supplier_id || "",
          name: data.name || "",
          mobile: data.mobile || "",
          address: data.address || "",
          status: data.status || "",
          created_by: data.created_by || "",
          created_date: data.created_date || "",
          updated_by: "",
          updated_date: "",
        });
        setGenerateNumber(data.supplier_id);
        setUpdateModal(true);
      } else {
        openNotificationModal(id, "Edit");
      }
    } else {
      setUpdateId(id);
      setUpdateData({
        id,
        supplier_id: data.supplier_id || "",
        name: data.name || "",
        mobile: data.mobile || "",
        address: data.address || "",
        status: data.status || "",
        created_by: data.created_by || "",
        created_date: data.created_date || "",
        updated_by: "",
        updated_date: "",
      });
      setGenerateNumber(data.supplier_id);
      setUpdateModal(true);
    }
  };

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    if (!validateForm(updateData)) return;

    try {
      setLoading(true);
      const formData = {
        ...updateData,
        supplier_id: generateNumber,
        updated_date: new Date().toISOString().slice(0, 19).replace("T", " "),
      };

      await axios.put(`${ApiUrl}/Api/supplier.php/${updateId}`, formData);

      const notification = notifications.find(
        (notif) =>
          notif.table_id === updateId.toString() &&
          notif.button_value === "Edit" &&
          notif.viewed === "false"
      );
      if (notification) {
        const currentTime = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        const notificationPayload = {
          id: notification.id,
          viewed: "true",
          updatedlenme: localStorage.getItem("username"),
          updated_date: currentTime,
          table_name: notification.table_name,
          table_id: notification.table_id,
          employe_id: notification.employe_id,
          status: notification.status,
          button_value: notification.button_value,
          time: notification.time,
          created_date: notification.created_date,
        };

        await axios.put(
          `${ApiUrl}/Api/notification.php/${notification.id}`,
          notificationPayload,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
      }

      toast.success("Updated successfully!", 3000, "topRight");
      closeUpdateModal();
      fetchData();
      fetchNotifications();
    } catch (error) {
      console.error("Error updating data:", error.message);
      toast.error("Failed to update data", 3000, "topRight");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleOpenModal = (id, supplier_id) => {
    const userRole = localStorage.getItem("role");

    if (userRole === "Employee") {
      if (checkNotificationStatus(id, "Delete")) {
        setDeleteId(id);
        setDeleteName(supplier_id);
        setDeleteShowModals(true);
      } else {
        openNotificationModal(id, "Delete");
      }
    } else {
      setDeleteId(id);
      setDeleteName(supplier_id);
      setDeleteShowModals(true);
    }
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
    setDeleteId("");
    setDeleteName("");
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await axios.delete(`${ApiUrl}/Api/supplier.php/${deleteId}`);

      const notification = notifications.find(
        (notif) =>
          notif.table_id === deleteId.toString() &&
          notif.button_value === "Delete" &&
          notif.viewed === "false"
      );
      if (notification) {
        const currentTime = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        const notificationPayload = {
          id: notification.id,
          viewed: "true",
          updated_by: localStorage.getItem("username"),
          updated_date: currentTime,
          table_name: notification.table_name,
          table_id: notification.table_id,
          employe_id: notification.employe_id,
          status: notification.status,
          button_value: notification.button_value,
          time: notification.time,
          created_date: notification.created_date,
        };

        await axios.put(
          `${ApiUrl}/Api/notification.php/${notification.id}`,
          notificationPayload,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
      }

      toast.success("Deleted successfully!", 3000, "topRight");
      handleCloseModal();
      fetchData();
      fetchNotifications();
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error("Failed to delete data", 3000, "topRight");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const filteredData = responseData.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      (item.supplier_id &&
        item.supplier_id.toLowerCase().includes(searchLower)) ||
      (item.name && item.name.toLowerCase().includes(searchLower)) ||
      (item.mobile && item.mobile.toLowerCase().includes(searchLower)) ||
      (item.address && item.address.toLowerCase().includes(searchLower)) ||
      (item.status && item.status.toLowerCase().includes(searchLower))
    );
  });

  const totalItems = filteredData.length;
  const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
  const currentItems = showAllItems
    ? filteredData
    : filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(1)}>
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  const handlePrint = () => {
    try {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
        <head>
          <title>Suppliers List</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
            .header { text-align: center; margin-bottom: 20px; }
            .badge { padding: 2px 6px; border-radius: 3px; font-size: 12px; }
            .badge.active { background-color: #28a745; color: white; }
            .badge.inactive { background-color: #dc3545; color: white; }
            .badge.default { background-color: #6c757d; color: white; }
            .table-secondary { background-color: #e2e3e5; }
            .table-danger { background-color: #f8d7da; }
            .table-info { background-color: #cff4fc; }
          </style>
        </head>
        <body>
          <div class="header"><h2>Suppliers List</h2></div>
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Supplier ID</th>
                <th>Name</th>
                <th>Mobile Number</th>
                <th>Address</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              ${filteredData
                .map((item, index) => {
                  const userId = localStorage.getItem("username");
                  const notification = notifications.find(
                    (notif) =>
                      notif.table_id === item.id.toString() &&
                      notif.employe_id === userId &&
                      notif.viewed === "false"
                  );
                  let rowClass = "";
                  if (notification) {
                    switch (notification.status) {
                      case "accepted":
                        rowClass = "table-secondary";
                        break;
                      case "rejected":
                        rowClass = "table-danger";
                        break;
                      case "requested":
                        rowClass = "table-info";
                        break;
                    }
                  }
                  const statusClass =
                    item.status === "Active"
                      ? "active"
                      : item.status === "Inactive"
                      ? "inactive"
                      : "default";
                  return `
                    <tr class="${rowClass}">
                      <td>${index + 1}</td>
                      <td>${item.supplier_id || ""}</td>
                      <td>${item.name || ""}</td>
                      <td>${item.mobile || ""}</td>
                      <td>${item.address || ""}</td>
                      <td><span class="badge ${statusClass}">${
                    item.status || ""
                  }</span></td>
                    </tr>
                  `;
                })
                .join("")}
            </tbody>
          </table>
        </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
      toast.success("Print dialog opened!", 3000, "topRight");
    } catch (error) {
      console.error("Error printing:", error);
      toast.error("Error printing. Please try again", 3000, "topRight");
    }
  };

  const exportPDF = () => {
    try {
      const doc = new jsPDF();
      doc.setFontSize(20);
      doc.text("Suppliers List", 14, 22);
      doc.setFontSize(12);
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 35);

      const tableColumn = [
        "S.No",
        "Supplier ID",
        "Name",
        "Mobile Number",
        "Address",
        "Status",
      ];
      const tableRows = filteredData.map((item, index) => {
        const userId = localStorage.getItem("username");
        const notification = notifications.find(
          (notif) =>
            notif.table_id === item.id.toString() &&
            notif.employe_id === userId &&
            notif.viewed === "false"
        );
        let rowStyle = "";
        if (notification) {
          switch (notification.status) {
            case "accepted":
              rowStyle = { fillColor: [226, 227, 229] };
              break;
            case "rejected":
              rowStyle = { fillColor: [248, 215, 218] };
              break;
            case "requested":
              rowStyle = { fillColor: [207, 244, 252] };
              break;
          }
        }
        return [
          index + 1,
          item.supplier_id || "",
          item.name || "",
          item.mobile || "",
          item.address || "",
          item.status || "",
          rowStyle,
        ];
      });

      autoTable(doc, {
        head: [tableColumn],
        body: tableRows.map((row) => row.slice(0, -1)),
        startY: 45,
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: { fillColor: [41, 128, 185], textColor: 255 },
        columnStyles: {
          0: { cellWidth: 15 },
          1: { cellWidth: 25 },
          2: { cellWidth: 30 },
          3: { cellWidth: 25 },
          4: { cellWidth: 40 },
          5: { cellWidth: 20 },
        },
        didParseCell: (data) => {
          if (data.section === "body") {
            const rowIndex = data.row.index;
            const rowStyle =
              tableRows[rowIndex][tableRows[rowIndex].length - 1];
            if (rowStyle) {
              data.cell.styles = { ...data.cell.styles, ...rowStyle };
            }
          }
        },
      });

      doc.save("supplier-list.pdf");
      toast.success("PDF exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting PDF:", error);
      toast.error("Error exporting PDF. Please try again.", 3000, "topRight");
    }
  };

  const copyToClipboard = () => {
    try {
      const headers = [
        "S.No",
        "Supplier ID",
        "Name",
        "Mobile Number",
        "Address",
        "Status",
      ];
      const rows = filteredData.map((item, index) => [
        index + 1,
        item.supplier_id || "",
        item.name || "",
        item.mobile || "",
        item.address || "",
        item.status || "",
      ]);

      const formattedText = [headers, ...rows]
        .map((row) => row.map((field) => `"${field}"`).join("\t"))
        .join("\n");

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(formattedText)
          .then(() => {
            toast.success(
              "Data copied to clipboard successfully!",
              3000,
              "topRight"
            );
          })
          .catch((err) => {
            console.error("Clipboard API failed:", err);
            fallbackCopy(formattedText);
          });
      } else {
        fallbackCopy(formattedText);
      }
    } catch (error) {
      console.error("Unexpected error copying to clipboard:", error);
      toast.error("Error copying data. Please try again.", 3000, "topRight");
    }
  };

  const fallbackCopy = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = 0;
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      if (successful) {
        toast.success("Data copied to clipboard!", 3000, "topRight");
      } else {
        toast.error("Failed to copy data", 3000, "topRight");
      }
    } catch (err) {
      console.error("Fallback copy failed:", err);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  const exportCSV = () => {
    try {
      const csvData = [
        ["S.No", "Supplier ID", "Name", "Mobile Number", "Address", "Status"],
        ...filteredData.map((item, index) => [
          index + 1,
          item.supplier_id || "",
          item.name || "",
          item.mobile || "",
          item.address || "",
          item.status || "",
        ]),
      ];

      const csvContent = csvData
        .map((row) => row.map((field) => `"${field}"`).join(","))
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "supplier-list.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("CSV file exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting CSV:", error);
      toast.error("Error exporting CSV. Please try again.", 3000, "topRight");
    }
  };
  const exportExcel = () => {
    try {
      const excelData = filteredData.map((item, index) => ({
        "S.No": index + 1,
        "Supplier ID": item.supplier_id || "",
        Name: item.name || "",
        "Mobile Number": item.mobile || "",
        Address: item.address || "",
        Status: item.status || "",
      }));

      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      const colWidths = [
        { wch: 8 },
        { wch: 15 },
        { wch: 25 },
        { wch: 15 },
        { wch: 40 },
        { wch: 12 },
      ];
      ws["!cols"] = colWidths;
      XLSX.utils.book_append_sheet(wb, ws, "Suppliers");
      XLSX.writeFile(wb, "supplier-list.xlsx");
      toast.success("Excel file exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting Excel:", error);
      toast.error("Error exporting Excel. Please try again.", 3000, "topRight");
    }
  };

  useEffect(() => {
    fetchData();
    fetchNotifications();
    const interval = setInterval(() => {
      fetchData();
      fetchNotifications();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}
      <div className="container-fluid py-3">
        <div className="d-flex mb-4">
          <h6 className="card-title m-2">Suppliers</h6>
          <button
            className="btn btn-primary btn-sm rounded-3"
            onClick={openModal}
          >
            Add <span className="ms-2">+</span>
          </button>
        </div>
        <div className="card shadow-sm mb-5">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex">
                <label className="form-label text-dark mt-2">Show : </label>
                <div>
                  <select
                    className="form-control mx-2"
                    onChange={handleItemsPerPageChange}
                    value={showAllItems ? "All" : itemsPerPage}
                  >
                    <option value="All">All</option>
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handlePrint}
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportPDF}
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={copyToClipboard}
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportCSV}
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportExcel}
                >
                  Excel
                </button>
              </div>
              <div className="search-container">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="card tableCard p-2">
              <div className="table-container">
                <table className="table table-layout-fixed w-100">
                  <thead className="bg-light">
                    <tr>
                      <th>S.No</th>
                      <th>Supplier ID</th>
                      <th>Name</th>
                      <th>Mobile Number</th>
                      <th>Address</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? (
                      currentItems.map((item, index) => {
                        const userId = localStorage.getItem("username");
                        const notification = notifications.find(
                          (notif) =>
                            notif.table_id === item.id.toString() &&
                            notif.viewed === "false"
                        );
                        let rowClass = "";
                        if (notification) {
                          switch (notification.status) {
                            case "accepted":
                              rowClass = "table-secondary";
                              break;
                            case "rejected":
                              rowClass = "table-danger";
                              break;
                            case "requested":
                              rowClass = "table-info";
                              break;
                          }
                        }
                        return (
                          <tr key={item.id} className={rowClass}>
                            <td>{index + 1}</td>
                            <td>{item.supplier_id}</td>
                            <td>{item.name}</td>
                            <td>{item.mobile}</td>
                            <td>{item.address}</td>
                            <td>
                              {item.status === "Active" ? (
                                <span className="badge bg-success text-white">
                                  Active
                                </span>
                              ) : item.status === "Inactive" ? (
                                <span className="badge bg-danger text-white">
                                  Inactive
                                </span>
                              ) : (
                                <span className="badge bg-secondary text-white">
                                  {item.status}
                                </span>
                              )}
                            </td>
                            <td>
                              <button
                                className="btn btn-light btn-sm mx-1"
                                onClick={() => handleUpdate(item.id, item)}
                              >
                                <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                              </button>
                              <button
                                className="btn btn-light btn-sm"
                                onClick={() =>
                                  handleOpenModal(item.id, item.supplier_id)
                                }
                              >
                                <i className="fa-solid fa-trash text-danger fs-6"></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No suppliers found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <p className="text-muted">
                    Showing{" "}
                    {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
                    {showAllItems
                      ? totalItems
                      : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                    of {totalItems} entries
                  </p>
                </div>
                <div className="col-lg-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-end">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(1)}
                          aria-label="First"
                        >
                          <span aria-hidden="true">««</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          aria-label="Previous"
                        >
                          <span aria-hidden="true">«</span>
                        </button>
                      </li>
                      {renderPageNumbers()}
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          aria-label="Next"
                        >
                          <span aria-hidden="true">»</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(totalPages)}
                          aria-label="Last"
                        >
                          <span aria-hidden="true">»»</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{
          display: showModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="addSupplierModalLabel"
        aria-hidden={!showModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="addSupplierModalLabel"
              >
                {actionType
                  ? `Send ${actionType} Request to Admin`
                  : "Add Supplier"}
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={actionType ? closeNotificationModal : closeModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {actionType ? (
                <form onSubmit={handleNotificationSubmit}>
                  <p className="text-center">
                    Do you want to request to {actionType.toLowerCase()} this
                    supplier?
                  </p>
                  <div className="text-center mt-4">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm px-4 me-2"
                      onClick={closeNotificationModal}
                    >
                      No
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm px-4"
                      disabled={isSubmitting}
                    >
                      Yes
                    </button>
                  </div>
                </form>
              ) : (
                <form onSubmit={handlesubmit}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="supplierId" className="form-label">
                          Supplier ID <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            formErrors.supplier_id ? "is-invalid" : ""
                          }`}
                          id="supplierId"
                          placeholder="Supplier ID will be generated"
                          value={generateNumber}
                          disabled
                        />
                        {formErrors.supplier_id && (
                          <div className="invalid-feedback">
                            {formErrors.supplier_id}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label">
                          Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            formErrors.name ? "is-invalid" : ""
                          }`}
                          id="name"
                          placeholder="Enter Name"
                          value={addData.name}
                          onChange={(e) =>
                            setAddData({ ...addData, name: e.target.value })
                          }
                          required
                        />
                        {formErrors.name && (
                          <div className="invalid-feedback">
                            {formErrors.name}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="mobile" className="form-label">
                          Mobile Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          maxLength="10"
                          className={`form-control ${
                            formErrors.mobile ? "is-invalid" : ""
                          }`}
                          id="mobile"
                          placeholder="Enter Mobile"
                          value={addData.mobile}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,10}$/.test(value)) {
                              setAddData({ ...addData, mobile: value });
                            }
                          }}
                          required
                        />

                        {formErrors.mobile && (
                          <div className="invalid-feedback">
                            {formErrors.mobile}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="address" className="form-label">
                          Address <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            formErrors.address ? "is-invalid" : ""
                          }`}
                          id="address"
                          placeholder="Enter Address"
                          value={addData.address}
                          onChange={(e) =>
                            setAddData({ ...addData, address: e.target.value })
                          }
                          required
                        />
                        {formErrors.address && (
                          <div className="invalid-feedback">
                            {formErrors.address}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="status" className="form-label">
                      Status <span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select ${
                        formErrors.status ? "is-invalid" : ""
                      }`}
                      id="status"
                      value={addData.status}
                      onChange={(e) =>
                        setAddData({ ...addData, status: e.target.value })
                      }
                      required
                    >
                      <option value="" disabled>
                        Select Status
                      </option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                    {formErrors.status && (
                      <div className="invalid-feedback">
                        {formErrors.status}
                      </div>
                    )}
                  </div>
                  <div className="text-center mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm px-4"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade ${updateModal ? "show" : ""}`}
        style={{
          display: updateModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="updateSupplierModalLabel"
        aria-hidden={!updateModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="updateSupplierModalLabel"
              >
                Update Supplier
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeUpdateModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleupdatesubmit}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="updateSupplierId" className="form-label">
                        Supplier ID <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          formErrors.supplier_id ? "is-invalid" : ""
                        }`}
                        id="updateSupplierId"
                        value={generateNumber}
                        disabled
                      />
                      {formErrors.supplier_id && (
                        <div className="invalid-feedback">
                          {formErrors.supplier_id}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="updateName" className="form-label">
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          formErrors.name ? "is-invalid" : ""
                        }`}
                        id="updateName"
                        placeholder="Enter Name"
                        value={updateData.name}
                        onChange={(e) =>
                          setUpdateData({ ...updateData, name: e.target.value })
                        }
                        required
                      />
                      {formErrors.name && (
                        <div className="invalid-feedback">
                          {formErrors.name}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="updateMobile" className="form-label">
                        Mobile Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="10"
                        className={`form-control ${
                          formErrors.mobile ? "is-invalid" : ""
                        }`}
                        id="updateMobile"
                        placeholder="Enter Mobile"
                        value={updateData.mobile}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setUpdateData({ ...updateData, mobile: value });
                          }
                        }}
                        required
                      />

                      {formErrors.mobile && (
                        <div className="invalid-feedback">
                          {formErrors.mobile}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="updateAddress" className="form-label">
                        Address <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          formErrors.address ? "is-invalid" : ""
                        }`}
                        id="updateAddress"
                        placeholder="Enter Address"
                        value={updateData.address}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            address: e.target.value,
                          })
                        }
                        required
                      />
                      {formErrors.address && (
                        <div className="invalid-feedback">
                          {formErrors.address}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="updateStatus" className="form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${
                      formErrors.status ? "is-invalid" : ""
                    }`}
                    id="updateStatus"
                    value={updateData.status}
                    onChange={(e) =>
                      setUpdateData({ ...updateData, status: e.target.value })
                    }
                    required
                  >
                    <option value="" disabled>
                      Select Status
                    </option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  {formErrors.status && (
                    <div className="invalid-feedback">{formErrors.status}</div>
                  )}
                </div>
                <div className="text-center mt-4">
                  <button type="submit" className="btn btn-primary btn-sm px-4">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade ${deleteShowModals ? "show" : ""}`}
        style={{
          display: deleteShowModals ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-confirm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
                  style={{ width: "80px", height: "80px", margin: "0 auto" }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
              </div>
              <h4 className="modal-title mb-3 text-center">Are you sure?</h4>
              <h6 className="mb-4 text-center">
                Do you really want to delete this
                <span className="text-primary">({deleteName})</span>?
              </h6>
              <div className="d-flex btn-group">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm flex-grow-1"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm flex-grow-1 mx-2"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {(showModal || updateModal || deleteShowModals) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
}

export default Supplier;
